import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  SaveArrearsRequestInput,
  PayrollSaveArrearsGraphQLRequest,
  PayrollSaveArrearsResponse,
} from '../types';

const payrollSaveArrearsMutation = gql`
  mutation PayrollSaveArrears($input: SaveArrearsRequestInput!) {
    payrollSaveArrears(input: $input) {
      code
      success
      message
      data {
        message
        requestId
        previewRequestBy
        saveRequestBy
        totalSuccess
        totalFailed
        processingResults {
          userId
          sourceMonth
          targetMonth
          arrearCause
          errorMessage
          savedArrearId
        }
      }
    }
  }
`;

export const saveArrears = (input: SaveArrearsRequestInput) => {
  return graphQLApi<PayrollSaveArrearsResponse, PayrollSaveArrearsGraphQLRequest>({
    query: payrollSaveArrearsMutation,
    queryVariables: { input },
  });
};

